var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Screen',{attrs:{"title":"Unauthorized"}},[_c('AppBar',{attrs:{"showBackButton":false}}),_vm._v(" "),_c('h1',{staticClass:"mt-5"},[_vm._v("Unauthorized!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }